import { CSSProperties, type HTMLAttributes, type ReactNode } from 'react';

import { Content, TabFilterGroupCustom } from './styles';

export interface IPageContentProps extends HTMLAttributes<HTMLDivElement> {
  tabs?: ReactNode;
  defaultTabValue?: string;
  onTabValueChange?: (value: string) => void;
  value?: string;
  tabContainerStyles?: CSSProperties;
}

export const PageContent = ({
  children,
  tabs,
  defaultTabValue,
  onTabValueChange,
  value,
  tabContainerStyles,
  ...props
}: IPageContentProps): JSX.Element => {
  return (
    <>
      {Boolean(tabs) && (
        <TabFilterGroupCustom
          type="single"
          defaultValue={defaultTabValue}
          onValueChange={onTabValueChange}
          value={value}
          style={tabContainerStyles}
        >
          {tabs}
        </TabFilterGroupCustom>
      )}
      <Content {...props}>{children}</Content>
    </>
  );
};
